import React, {PropsWithChildren} from 'react'
import styles from './UIGameChatContainer.module.scss'
import clsx from 'clsx'
// eslint-disable-next-line no-restricted-imports
import {getLobbyImagePath} from '../../../../../../code/client/shared/scripts/ui_utils/Utils'
import {LobbyImage} from '@colonist/types'

export function UIGameChatContainer({
    children,
    isMinimized,
    setIsMinimized,
    minimizedTitle,
    showMinimizedNotification,
}: PropsWithChildren<{
    isMinimized?: boolean
    setIsMinimized?: React.Dispatch<React.SetStateAction<boolean>>
    minimizedTitle?: string
    showMinimizedNotification?: boolean
}>) {
    const setIsMinimizedWrapper = (state: boolean) => {
        if(setIsMinimized) setIsMinimized(state)
    }

    if(isMinimized) {
        return (
            <div className={styles.container}>
                <div className={styles.minimized} data-testid="chat-minimize-toggle">
                    <div className={styles.minimizedTitle}>
                        {minimizedTitle}
                        {showMinimizedNotification === true && <span className={styles.minimizedRedDot} />}
                    </div>
                    <div className={styles.chatMinimizeButton} onClick={() => setIsMinimizedWrapper(false)}>
                        <img src={getLobbyImagePath(LobbyImage.DownArrowBlack)} />
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className={clsx(styles.container, styles.maximized)}>
                {children}
            </div>
        )
    }
}
